import classNames from 'classnames'

const CloseIcon = ({ handler, className }) => {
  return (
    <svg
      onClick={handler}
      className={classNames('close_icon', className)}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="white" />
      <path d="M29 19L19 29" stroke="#17171C" strokeWidth="2" strokeLinecap="round" />
      <path d="M19 19L29 29" stroke="#17171C" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export default CloseIcon
